<template>
    <el-dialog
        class="detail"
        :visible.sync="paymentMethodVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        :title="dialogTitle"
        :modal-append-to-body="false"
        append-to-body
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div class="container">
            <template v-if="paymentList.length > 0">
                <div class="payment-tipbar">Payment Method</div>
                <div
                    class="payment-methods"
                    :class="{ error: paymentMethodIsRequired }"
                >
                    <div
                        class="payment-methods-item"
                        v-for="item of paymentList"
                        :key="item.label"
                    >
                        <el-radio
                            v-model="payMethod"
                            :label="item.value"
                            :disabled="item.disabled"
                            @change="payMethodChange(item)"
                        >
                            {{ item.label }}
                            <template v-if="item.label == 'Balance Payment'">
                                ( Balance :
                                <span class="balance-num"
                                    >${{ entityInfoData.balance }}</span
                                >)
                            </template>
                        </el-radio>
                    </div>
                </div>
            </template>
            <div class="table-wrapper">
                <el-table
                    ref="shippingTable"
                    :data="tableData"
                    style="width: 100%"
                >
                    <el-table-column label="Order" prop="order_sn" min-width="120">
                        <template slot-scope="scope">
                            <div>#{{ scope.row.plt_order_sn }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Country"
                        prop="country"
                    ></el-table-column>
                    <el-table-column
                        label="Channel Name"
                        prop="channel_name"
                        min-width="150"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        label="Items"
                        prop="goods_num"
                    ></el-table-column>
                    <el-table-column label="Ship Cost" prop="act_ship_cost">
                        <template slot-scope="scope">
                            <div>{{ currency + scope.row.act_ship_cost }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="IOSS"
                        prop="ioss_fee"
                    >
                    <template slot-scope="scope">
                            <div>{{ currency + scope.row.ioss_fee }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Order Amount" prop="act_amount">
                        <template slot-scope="scope">
                            <div>{{ currency + scope.row.act_amount }}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="checkout-wrapper">
                <div class="checkout-box">
                    <!-- <div class="subtotal">
                        <p class="subtotal-label">Subtotal</p>
                        <p class="subtotal-value">{{currency + subtotal }}</p>
                    </div>
                    <div class="discount">
                        <p class="discount-label">Discount</p>
                        <p class="discount-value">-{{currency +  discount }}</p>
                    </div>
                    <el-divider></el-divider> -->
                    <div class="shipping">
                        <p class="shipping-label">Shipping Fee</p>
                        <p class="shipping-value">
                            {{ currency + shipping_fee }}
                        </p>
                    </div>
                    <div class="ioss" v-if="ioss_fee > 0">
                        <p class="ioss-label">IOSS Fee</p>
                        <p class="ioss-value">{{ currency + ioss_fee }}</p>
                    </div>
                    <div class="total">
                        <p class="total-label">Order Total</p>
                        <p class="total-value">{{ currency + total }}</p>
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Pay Now</el-button
            >
            <el-button size="small" @click="closeDialog">Close</el-button>
        </span>
        <payConfirm
            :paymentVisible.sync="paymentVisible"
            @onClosed="payConfirmClosed"
            :orderId="this.order_ids"
        ></payConfirm>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import payConfirm from "@/common/components/payConfirm.vue";
export default {
    components: {
        payConfirm,
    },
    data() {
        return {
            payMethod: "balance",
            paymentList: [
                {
                    label: "Balance",
                    value: "balance",
                    disabled: false,
                },
                {
                    label: "Paypal",
                    value: "paypal",
                    disabled: false,
                } /* ,
                {
                    label: "Western Union",
                    value: "0",
                    disabled: true,
                },
                {
                    label: "Bank Transfer Payment",
                    value: "0",
                    disabled: true,
                }, */,
            ],
            entityInfoData: {},
            tableData: [],
            paymentMethodIsRequired: false,
            subtotal: "",
            shipping_fee: "",
            discount: "",
            total: "",
            ioss_fee: "",
            currency: "",
            paymentVisible: false,
            loading: false,
            order_ids: [],
        };
    },
    methods: {
        closeDialog() {
            this.$emit("update:paymentMethodVisible", false);
            this.$parent.getOrdersList && this.$parent.getOrdersList();
        },
        getEntityInfo() {
            cmofferApi.entityInfo({}, "get").then((res) => {
                if (res) {
                    console.log(res);
                    this.entityInfoData = res.data;
                }
            });
        },
        saleOrderList() {
            cmofferApi
                .saleOrderList(
                    {
                        ids: this.selectList,
                    },
                    "post"
                )
                .then((res) => {
                    if (res) {
                        console.log(res);
                        this.tableData = res.data.orders;
                        this.order_ids =  res.data.orders.map((item) => {
                                return item.id;
                            });
                        this.discount = res.data.total_discount.toFixed(2);
                        this.total = res.data.total_amount.toFixed(2);
                        this.shipping_fee =
                            res.data.total_act_ship_cost.toFixed(2);
                        this.ioss_fee = res.data.total_ioss_fee.toFixed(2);
                        this.currency = res.data.currency;
                    }
                });
        },
        payMethodChange(val) {
            this.paymentMethodIsRequired = false;
        },
        save() {
            this.loading = true;
            cmofferApi
                .batchPay(
                    {
                        ids: this.order_ids,
                        pay_method: this.payMethod,
                    },
                    "post"
                )
                .then((res) => {
                    this.loading = false;
                    this.$ga.event("ecommerce", "payment_success");
                    if (res) {
                        this.$message.success(
                            this.$i18n.locale == "zh" ? "成功" : "Success"
                        );
                        if (this.payMethod == "paypal") {
                            this.paymentVisible = true;
                            window.open(res.data.links[1].href);
                        } else {
                            this.closeDialog();
                        }
                    }
                });
        },
        payConfirmClosed(status) {
            console.log("status: ", status);
            if (status != 1) {
                this.closeDialog();
            }
        },
    },
    props: {
        paymentMethodVisible: Boolean,
        isBatch: Boolean,
        tableItem: Object,
        selectList: Array,
        dialogTitle: String,
    },
    watch: {
        paymentMethodVisible() {
            if (this.paymentMethodVisible) {
                this.getEntityInfo();
                this.saleOrderList();
                console.log(this.selectList);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    .payment-tipbar {
        background-color: #f3f3f3;
        padding: 8px 20px;
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        line-height: 26px;
        font-size: 13px;
        color: $color-333333;
        margin: 20px 0;
        a {
            font-weight: 800;
            color: $color-primary-blue;
        }
        i {
            font-weight: 600;
            font-size: 14px;
            margin-right: 10px;
        }
    }
    .payment-methods {
        display: table;
        flex-wrap: wrap;
        padding: 5px;
        border: 1px solid transparent;
        .payment-methods-item {
            font-size: 13px;
            height: 30px;
            line-height: 30px;
            margin-bottom: 5px;
            .balance-num {
                font-weight: bold;
            }
        }
    }
    .table-wrapper {
        margin: 30px 0 40px;
    }
    .checkout-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
        padding-bottom: 60px;
        .checkout-box {
            min-width: 250px;
            max-width: 300px;
            padding: 10px;
            > div:not(:last-child) {
                margin-bottom: 20px;
            }
            .subtotal,
            .shipping,
            .discount,
            .ioss {
                font-size: 13px;
                display: flex;
                justify-content: space-between;
                &-label {
                    color: $color-808080;
                }
                &-value {
                    // color: #9b3c44;
                    color: $color-333333;
                }
            }
            .discount {
                &-value {
                    color: #9b3c44;
                }
            }
            .total {
                font-size: 16px;
                display: flex;
                justify-content: space-between;
                .total-label {
                    color: $color-333333;
                }
                .total-value {
                    color: #9b3c44;
                }
            }
            .tip {
                color: $color-333333;
                font-size: 15px;
                line-height: 22px;
            }
            .subtip {
                margin-top: 20px;
                color: #666;
                font-size: 14px;
                font-style: italic;
                line-height: 20px;
                text-align: right;
            }
        }
    }
}
</style>
